import React from 'react';
import styled from 'styled-components';
import leftdate from '../../../assets/icons/left-date.svg';
import rightdate from '../../../assets/icons/right-date.svg';

const Button = styled.button.attrs((props: any) => ({
  left: props.left,
  right: props.right
}))`
  background-color: #ffffff;
  width: 48px;
  height: 48px;
  border-radius: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 1;
  left: ${(props) => props.left};
  right: ${(props) => props.right};
`;

interface IProps {
  leftDate: boolean;
  right?: string;
  left?: string;
  tabs?: any[];
  toggleTab: (id: string) => void;
  selectIndex: (courseId: number) => void;
  courseIndex: number;
}

export function DateNavigator({
  leftDate,
  right,
  left,
  tabs,
  toggleTab,
  selectIndex,
  courseIndex
}: Readonly<IProps>) {
  const handleClick = () => {
    const primerElemento = tabs && tabs[0];

    if (leftDate) {
      if (typeof primerElemento === 'string') {
        if (tabs && courseIndex > 0) {
          toggleTab((courseIndex - 1).toString() || '');
          selectIndex(courseIndex - 1);
        }

        return;
      }

      if (tabs && courseIndex >= 0) {
        toggleTab(tabs[courseIndex - 1].id || '');
        selectIndex(courseIndex - 1);
      }
    }

    if (!leftDate) {
      if (typeof primerElemento === 'string') {
        if (tabs && courseIndex <= tabs?.length - 1) {
          toggleTab((courseIndex + 1).toString() || '');
          selectIndex(courseIndex + 1);
        }
      } else if (tabs && courseIndex < tabs?.length - 1) {
        toggleTab(tabs[courseIndex + 1].id || '');
        selectIndex(courseIndex + 1);
      }
    }
  };

  return (
    <Button
      right={right}
      left={left}
      onClick={() => handleClick()}
      data-testid="dateNavigatorButton"
    >
      <img src={leftDate ? leftdate : rightdate} alt="arrow navigator" />
    </Button>
  );
}
